<bspk-form-field [controlId]="controlId()"
                 [errorMessage]="errorState()"
                 [helperText]="helperText()"
                 [label]="label()"
                 [required]="required()">

  <div data-datepicker
       [attr.data-disabled]="disabled() ? true : null"
       [attr.data-invalid]="errorState() ? true : null"
       [attr.data-readonly]="readOnly() ? true : null"
       [attr.data-size]="size()">
    <input placeholder="mm/dd/yyyy"
           [attr.aria-label]="label()"
           [attr.aria-labelledby]="labelId"
           [disabled]="disabled()"
           [id]="controlId()"
           [matDatepicker]="picker"
           [max]="max()"
           [min]="min()"
           [readOnly]="readOnly() || null"
           [value]="value()?.toISOString()"
           (blur)="handleBlur($event)"
           (dateChange)="handleChange($event)">

    <mat-datepicker-toggle data-trailing [disabled]="disabled() || readOnly()" [for]="picker" />
  </div>

  <mat-datepicker #picker />
</bspk-form-field>
